import CustomLayout from '@/common/Layout';
import ApproverList from './components/approverList';

const ApproverGatepass = () => {
  return (
    <>
      <CustomLayout sider="true">
        <ApproverList />
      </CustomLayout>
    </>
  );
};

export default ApproverGatepass;
